import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import search_utils from "ulysses/widgets/search/utils";
import * as d3 from "d3";
import topojson from "topojson";
import markup from "ulysses/widgets/charts/chart.html";
import bar_chart from "ulysses/widgets/charts/bar_chart";
import pie_chart from "ulysses/widgets/charts/pie_chart";
import choropleth_chart from "ulysses/widgets/charts/cloropleth_chart";

"use strict";

function find_index(extractor, array, value) {
    var found = -1;
    $.each(array, function(idx, item) {
        if (extractor(item) === value) {
            found = idx;
            return false;
        }
        return null;
    });
    return found;
}

function DatasetModel(current_data) {
    var dataset_model = this;
    $.extend(this, {
       "dimensions":ko.observableArray([]),
       "values":ko.observableArray([]),
       "selected_dataset":ko.observable(null),
       "sub_dimensions":ko.observableArray(null),
       "sub_pivots":ko.observableArray(null),
       "dataset": ko.observable(current_data.dataset),
       "charttype": ko.observable(current_data.charttype),
       "map_file": ko.observable(current_data.map_file),
       "dimension": ko.observable(current_data.dimension),
       "sub_dimension":ko.observable(current_data.sub_dimension),
       "pivot": ko.observable(current_data.pivot),
       "sub_pivot": ko.observable(current_data.sub_pivot),
       "pivot_on_same_chart":ko.observable(current_data.pivot_on_same_chart),
       "chart_title": ko.observable(current_data.chart_title),
       "order_by": ko.observable(current_data.order_by),
       "limit": ko.observable(current_data.limit),
       "path": ko.observable(current_data.path),
       "extra_chart_filter": ko.observable(current_data.extra_chart_filter),
       "extra_solr_filter": ko.observable(current_data.extra_solr_filter),
       "caption_no_dimension": ko.observable(current_data.caption_no_dimension),
       "caption_no_pivot": ko.observable(current_data.caption_no_pivot),
       "show_as_grid": ko.observable(current_data.show_as_grid),

        add_series: function(ev,ui) {
            this.series.push({
                "value":ko.observable(null),
                "seriestype":ko.observable(null),
                "alt_axis":ko.observable(false),
                "stacked":ko.observable(false)
            });
            return false;
        },

        remove_series: function(model, ev) {
            dataset_model.series.remove(model);
        },
        toggle_alt_axis: function(model,ev) {
            model.alt_axis(!ko.unwrap(model.alt_axis));
        },
        toggle_stacked: function(model,ev) {
            model.stacked(!ko.unwrap(model.stacked));
        }
    });


    this.allowed_series_types = ko.pureComputed(function() {
           var ctype = ko.unwrap(dataset_model.charttype);
           if (!ctype) return [];
           if (ctype == "bar") {
               return ["bar", "line", "spline", "area", "step", "area-spline", "area-step"];
           } else if (ctype == "pie") {
               return ["pie", "donut"];
           }
           else if (ctype == "choropleth")
               return ["choropleth"];
           return [];
    });

    if (current_data.series) {
        var series = [];
        $.each(current_data.series, function(idx, serie) {
            series.push({
                "value":ko.observable(serie.value),
                "seriestype":ko.observable(serie.seriestype),
                "alt_axis":ko.observable(serie.alt_axis || false),
                "stacked":ko.observable(serie.stacked || false)
            });
        });

        this.series  = ko.observableArray(series);
    }
    else {
       this.series = ko.observableArray([{
           "value": ko.observable(current_data.value),
           "seriestype": ko.observable("bar"),
           "alt_axis":ko.observable(false),
           "stacked":ko.observable(false)
       }]);
    }
    this.selected_dataset.subscribe(function(dataset) {
        if (dataset) {
            var allowed_dims = $.map(ko.unwrap(dataset.dimensions), function(val,idx) {
                return val && ko.unwrap(val.field);
            });
            dataset_model.dimensions(allowed_dims);
            dataset_model.dataset(ko.unwrap(dataset.name));
            dataset_model.dimension.notifySubscribers(ko.unwrap(dataset_model.dimension));
            dataset_model.pivot.notifySubscribers(ko.unwrap(dataset_model.pivot));
        }
    });
    this.dimension.subscribe(function(newvalue) {
        var dataset = ko.unwrap(dataset_model.selected_dataset);
        var old_sub_dim = ko.unwrap(dataset_model.sub_dimension);
        dataset_model.sub_dimension(null);
        if (dataset && newvalue) {
            var dimensions = ko.unwrap(dataset.dimensions);
            var dimension = null;
            $.each(dimensions, function(idx,val) {
                if (val.field == newvalue) {
                    dimension = val;
                    return false;
                }
                return null;
            });
            if (dimension) {
                if (dimension.sub_dimensions) {
                    dataset_model.sub_dimensions(dimension.sub_dimensions);
                    if (old_sub_dim && find_index(function(i) { return i.field; }, dimension.sub_dimensions, old_sub_dim) >= 0)
                        dataset_model.sub_dimension(old_sub_dim);
                    return;
                }
            }
        }
        dataset_model.sub_dimensions(null);
    });

    this.pivot.subscribe(function(newvalue) {
        var dataset = ko.unwrap(dataset_model.selected_dataset);
        var old_sub_pivot = ko.unwrap(dataset_model.sub_pivot);
        dataset_model.sub_pivot(null);
        if (dataset && newvalue) {
            var dimensions = ko.unwrap(dataset.dimensions);
            var dimension = null;
            $.each(dimensions, function(idx,val) {
                if (val.field == newvalue) {
                    dimension = val;
                    return false;
                }
                return null;
            });
            if (dimension) {
                if (dimension.sub_dimensions) {
                    dataset_model.sub_pivots(dimension.sub_dimensions);
                    if (old_sub_pivot && find_index(function(i) { return i.field; }, dimension.sub_dimensions, old_sub_pivot) >= 0)
                        dataset_model.sub_pivot(old_sub_pivot);
                    return;
                }
            }
        }
        dataset_model.sub_pivots(null);
    });

}
$(document).ready(function() { $(markup).appendTo($("body")); });


var select_chart = function select_chart(current_data) {
    var res = Promise.Deferred();
    var cdata = new DatasetModel(ko.toJS(current_data || {}));
    var charts =uly.api.start().follow("uly:datasets").follow("uly:cube").done(function(datasets) {
        cdata.datasets = datasets;
        var current_dataset = ko.unwrap(cdata.dataset);
        if (current_dataset) {
            $.each(datasets, function(idx,val) {
                if (val.name == current_dataset)
                    cdata.selected_dataset(val);
            });
        }

        var dialog = uly.dialogs.execute($("#chart-picker-tmpl").html() , {
            "title":_("chart_title_select_dataset", "Select Dataset"),
            "raw_data":true
        }, cdata).done(function([result]) {
            res.resolve({
                "dataset":ko.unwrap(result.dataset),
                "path":ko.unwrap(result.path),
                "series":ko.toJS(result.series),
                "dimension":ko.unwrap(result.dimension),
                "sub_dimension":ko.unwrap(result.sub_dimension) || null,
                "charttype":ko.unwrap(result.charttype),
                "map_file": ko.unwrap(result.map_file),
                "pivot":ko.unwrap(result.pivot),
                "sub_pivot":ko.unwrap(result.sub_pivot) || null,
                "pivot_on_same_chart": ko.unwrap(result.pivot_on_same_chart),
                "chart_title":ko.unwrap(result.chart_title),
                "order_by":ko.unwrap(result.order_by),
                "limit":ko.unwrap(result.limit),
                "extra_chart_filter":ko.unwrap(result.extra_chart_filter),
                "extra_solr_filter":ko.unwrap(result.extra_solr_filter),
                "caption_no_dimension": ko.unwrap(result.caption_no_dimension),
                "caption_no_pivot": ko.unwrap(result.caption_no_pivot),
                "show_as_grid": ko.unwrap(result.show_as_grid)
            });
        }).fail(res.reject);

    }).fail(res.reject);
    return res.promise();
};

var modify_chart = function modify_chart(widget_model) {
    var res = Promise.Deferred();
    select_chart(ko.unwrap(widget_model.settings)).done(function(result) {
        console.log("modify chart:", result);
        if (!result.sub_pivot)
            result.sub_pivot = null;
        if (!result.sub_dimension)
            result.sub_dimension = null;
        if (!result.pivot) { result.pivot = null; }
        var new_settings = $.extend({}, ko.unwrap(widget_model.settings), result);
        widget_model.settings(new_settings);
        uly.publish("page.savesettings");
        res.resolve(new_settings);
    }).fail(res.reject);
    return res.promise();
};

var reload_chart = function reload_chart(widget_model) {
    widget_model.refresh();
};

/*
    function ChartModel(params) {
        var settings = params.settings;

        $.extend(this, {
            "chart_spec":settings,
            "chart_model": create_chart_model(settings),
            "style":ko.computed(function() {
                var result = ko.unwrap(params.style);
                if (result == "admin" || result == "top" || result=="left")
                    return result;
                return "left";
            }),
            "menu":ko.computed(function() {
                var result = ko.observable();
                var value = ko.unwrap(params.spec);
                if (Object.isObject(value)) {
                    return value;
                } else if (!value) {
                    return null;
                }
                return uly.api.start().follow("uly:app").follow(value);
            }).extend({"async":null}),
            "init":function(elts, model) {
                $(elts).find(".treeview").tree();
            }
        });
    }

    ko.components.register("chartcomponent", {
        viewModel:ChartModel,
        template: markup
    });
*/

function build_chart_settings(settings_obs) {
        //extend missing props without losing exiting props.
        var new_settings = $.extend({
            "dataset":null,
            "path":null,
            "value":null,
            "dimension":null,
            "sub_dimension":null,
            "charttype":null,
            "map_file": null,
            "pivot":null,
            "sub_pivot":null,
            "pivot_on_same_chart":null,
            "chart_title":null,
            "order_by":null,
            "limit":10,
            "extra_chart_filter":null,
            "extra_solr_filter":null,
            "caption_no_dimension": null,
            "caption_no_pivot": null,
            "show_as_grid": null
        }, ko.unwrap(settings_obs));
        //upgrade settings to multi-series
        if (!new_settings.series || !ko.unwrap(new_settings.series) || !ko.unwrap(new_settings.series).length) {
            new_settings.series = [
                {"value":new_settings.value, "seriestype":new_settings.charttype }
            ];
        }
        delete new_settings.value;
        return new_settings;
}

function build_chart_model(settings_obs, context) {
        var new_settings = build_chart_settings(settings_obs);

        var data = {
            "as_grid": ko.observable(ko.unwrap(new_settings.show_as_grid) && ko.unwrap(new_settings.charttype) == "bar"),
            "toggle_grid": function() {
                if (!data.can_show_as_grid()) {
                    data.as_grid(false);
                } else {
                    data.as_grid(!data.as_grid());
                }
            },
            "can_show_as_grid": ko.pureComputed(() => {
                return ko.unwrap(data.settings).charttype == "bar";
            }),
            "icon":ko.observable("fa-unknown"),
            "colour":ko.observable("tomato"),
            "data":ko.observableArray([]),
            "map":ko.observable({}),
            "dataset_meta":ko.observable(null),
            "chart_title":ko.observable(null),
            "url":ko.observable(null),
            "local_params": ko.observable(null),
            "hardcoded_model": ko.observable(null),
            "drill_down_value":function(filter) {
                data.details_shown(false);
                data.column_filter(filter);
                var filter_obs = ko.unwrap(data.search_settings).filter;
                if (ko.isWritableObservable(filter_obs)) {
                    filter_obs(ko.unwrap(data.filter));
                } else if (!ko.isObservable(filter)) {
                    ko.unwrap(data.search_settings).filter = ko.unwrap(data.filter);
                }
                data.details_shown(true);
            },
            "details_shown": ko.observable(false),
            "toggle_detail_action":function() {
                data.details_shown(!data.details_shown());
            },
            "column_expression": ko.observable(null),
            "pivot_expression": ko.observable(null),
            "chart_filter":ko.observable(null),
            "column_filter":ko.observable(null),
            "search_settings": ko.observable(search_utils.ensure_settings_complete({
                "navigable":false,
                "contextual":false,
                "filter": ko.observable(null),
                "parameters":{
                    _search_body:ko.observable(null)
                },
                "facets_visible": false
            })[0]),
            "settings": settings_obs,
            "new_settings": new_settings,
        };
        data.title = ko.pureComputed(() => {
            var ct = ko.unwrap((ko.unwrap(settings_obs)||{}).chart_title);
            var dst = ko.unwrap((ko.unwrap(data.dataset_meta) || {}).title);
            return ct || dst;
        });

        ko.unwrap(data.search_settings).hardcoded_model = ko.pureComputed(function() {
            return ko.unwrap(data.hardcoded_model);
        });

        ko.unwrap(data).filter = ko.pureComputed(function() {
            var local_params = ko.unwrap(data.local_params);

            var f1 = ko.unwrap(ko.unwrap(data).chart_filter);
            var f2 = ko.unwrap(ko.unwrap(data).column_filter);
            var filters = [];
            if (f1) filters.push(f1);
            if (f2) filters.push(f2);

            if (ko.unwrap(new_settings.path)) {
                var path = ko.unwrap(new_settings.path);
                var entity = uly.utils.get_bound_resource(context);
                if (path && entity) {
                    if (path.indexOf(":") > 0) {
                        path = path.split(":")[1];
                    }
                    if (path.indexOf(",") > 0) {
                        filters.push(path.split(",").map((p) => "_parents:" + entity.unique_id + "." + p).join(" OR "));
                    } else {
                        filters.push("_parents:" + entity.unique_id + "." + path);
                    }
                }
            };
            var new_filters = [];
            $.each(filters, function(idx, f) {
                if (Array.isArray(f)) {
                    if (f.length > 1) {
                        new_filters.push( "(" + f.join(") AND (") + ")");
                    } else new_filters.push(f[0]);
                } else if (f.length) new_filters.push(f);
            });
            if (new_filters.length) {
                if (new_filters.length == 1) {
                    new_filters = new_filters[0];
                } else {
                    new_filters = "(" + new_filters.join(") AND (") + ")";
                }
            } else new_filters = null;

            if (new_filters) {
                if (local_params)
                   return local_params + new_filters;
                return new_filters;
            }
            return null;
        });

        return data;
}

function rebuild_chart(settings_obs, data_obs, context, queue) {
    var settings = ko.unwrap(settings_obs);

    var chart = ko.unwrap(settings.dataset);
    var dimension = ko.unwrap(settings.dimension);
    var sub_dimension = ko.unwrap(settings.sub_dimension);
    var series = ko.unwrap(settings.series);
    var pivot = ko.unwrap(settings.pivot);
    var sub_pivot = ko.unwrap(settings.sub_pivot || null);
    var limit = ko.unwrap(settings.limit) || undefined;
    var order_by = ko.unwrap(settings.order_by) || undefined;
    var extra_chart_filter = ko.unwrap(settings.extra_chart_filter);

    var dataset_meta = null;
    var dataset = uly.api.start().follow("uly:datasets").follow("find", { "rel":chart });
    var main_dimension = null;
    if (sub_dimension) {
        main_dimension = dimension;
        dimension = sub_dimension;
    }

    dataset.done(function(result) {
        dataset_meta = result;
    });
    var path = ko.unwrap(settings.path);
    var bound = false;
    var entity = uly.utils.get_bound_resource(context);
    var group_by = dimension;
    if (order_by === "dimension") {
        order_by = dimension;
    }
    else { order_by = "_val1 desc"; }

    var main_pivot = null;
    if (sub_pivot) {
        main_pivot = pivot;
        pivot = sub_pivot;
    }

    if (pivot) {
        group_by = [pivot, dimension];
    }
    var aggregates = [];
    if (series) {
        $.each(series, function(idx, serie) {
            if (ko.unwrap(serie.value)) {
                aggregates.push(ko.unwrap(serie.value));
            }
        });
    }
    if (path && entity) {
        dataset = dataset.follow("uly:results", {
            "origin":entity.unique_id,
            "path":path,
            "group_by":group_by,
            "aggregates":aggregates,
            "limit":limit,
            "order_by":order_by,
            "filters":extra_chart_filter
        });
        bound = true;
    } else {
        dataset = dataset.follow("uly:results", {
            "group_by":group_by,
            "aggregates":aggregates,
            "order_by":order_by,
            "limit":limit,
            "filters":extra_chart_filter
        });
    }

    return dataset.then(function(result) {
        var model = ko.unwrap(data_obs);
        result = result || {};
        model.icon(result.icon);
        model.colour(result.colour);
        model.data(result.data);
        model.map(result.map);
        model.dataset_meta(dataset_meta);
        var filters = null;
        if (dataset_meta.filters) {
            if (Array.isArray(dataset_meta.filters))
            {
                filters = $.map(dataset_meta.filters, function(value) {
                    if (value.solr_filter && value.solr_filter.length) {
                        return `(${value.solr_filter})`;
                    }
                }).join(" AND ");
            }
            else if (dataset_meta.filters.length) {
                filters = dataset_meta.filters;
            }
        }
        if (dataset_meta.fact_entity)
        {
            if (filters && filters.length) {
                filters = `(${filters}) AND (type:${dataset_meta.fact_entity})`;
            }
            else { filters = `type:${dataset_meta.fact_entity}`; }
        }

        if (ko.unwrap(settings.extra_solr_filter) && ko.unwrap(settings.extra_solr_filter).length) {
            if (filters && filters.length) {
                filters = `(${filters}) AND (${ko.unwrap(settings.extra_solr_filter)})`;
            }
            else { filters = ko.unwrap(settings.extra_solr_filter); }
        }
        model.local_params(dataset_meta.local_params);
        model.hardcoded_model(ko.unwrap(dataset_meta.hardcoded_model));
        model.chart_filter(filters);
        var candidates = null;
        if (dimension && dataset_meta.dimensions) {
            if (main_dimension) {
                candidates = dataset_meta.dimensions
                    .filter(function(d) { return d.field == main_dimension; })
                    .map(function(value) {
                        var sub_vals = value.sub_dimensions.filter(function(v) {
                            return (v.field == dimension);
                        });
                        if (sub_vals.length)
                            return sub_vals[0];
                        return null;
                    })
                    .filter(function(v) { return v; });
            } else {
                candidates = dataset_meta.dimensions.filter(function(v) { return v.field == dimension; });
            }
            if (candidates.length) {
                model.column_expression(candidates[0].solr_filter);
            }
        }
        candidates = null;
        if (pivot && dataset_meta.dimensions) {
            if (main_pivot) {
                candidates = $.map(dataset_meta.dimensions, function(value,idx) {
                    if (value.field == main_pivot)  {
                        var sub_vals = $.map(value.sub_dimensions, function(v,i) {
                            if (v.field == pivot)
                                return v;
                        });
                        if (sub_vals.length) return sub_vals[0];
                    }
                });
            } else {
                candidates = $.map(dataset_meta.dimensions, function(value,idx) {
                    if (value.field == pivot)
                        return value;
                });
            }
            if (candidates.length) { model.pivot_expression(candidates[0].solr_filter); }
        }
        return { "result": result, "dataset_meta": dataset_meta };
    });
}

ko.bindingHandlers.subchart = {
    "init": function(elt, va, allbindings, model, context) {
        var chart_data = build_chart_model(va(), context);
        chart_data.details_shown.subscribe(function(newval) {
            console.log("parent", parent);
            if (allbindings().activate) {
                allbindings().activate(newval);
            }
        })
        if (allbindings().search_settings) {
            chart_data.search_settings = allbindings().search_settings;
        }
        $(elt).data("chart_data", chart_data);
        var child = context.createChildContext(chart_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update": function(elt, va, allbindings, model, context) {
        var data_obs = $(elt).data("chart_data");
        var queue = ko.unwrap(allbindings().queue);
        var settings = ko.unwrap(ko.unwrap(data_obs).settings);
        var ready = allbindings().ready;
        rebuild_chart(settings, data_obs, context, queue).then(()=> {
            if (ready) ready.resolve(true);
        });
    }
};

ko.bindingHandlers.chart = {
    "init":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title(_("chart_loading", "Loading..."));
        widget_model.icon("fa fa-dashboard");
        widget_model.show_header(true);
        //calculate width of widget container. seems to fix resizing bug on first chart:
        var section_width = $(elt).closest("section").width();
        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("chart_caption_select_chart", "Select Chart"), 
            "icon":"fa-edit", 
            "action":function(e){
                modify_chart(widget_model).done(function() {
                    widget_model.refresh();
                });
            },
            "colour":"default",
            "permission": "editpage"
        });
        var chart_data = build_chart_model(widget_model.settings, context);
        widget_model.settings(chart_data.new_settings);
        chart_data.remove_action =function(ev) {
                var bindingcontext = ko.contextFor($(ev.target)[0]);
                if (context.widget_list) {
                    context.widget_list.splice(ko.unwrap(context.$index), 1);
                    uly.publish("page.savesettings");
                }
        };
        //setup force refresher
        if (!ko.isObservable(widget_model.refresher)) {
            widget_model.refresher = ko.observable(0);
            widget_model.refresh = function() { widget_model.refresher((widget_model.refresher() || 0) + 1); };
        }

        var entity_data = ko.observable(null);
        $(elt).data("widget_data", entity_data);
        $(elt).data("chart_data", chart_data);
        var child = context.createChildContext(chart_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var data_obs = $(elt).data("chart_data");
        var widget_model = ko.unwrap(va());
        //subscribe to refresher
        var refresher_value = widget_model.refresher();

        var settings = ko.unwrap(widget_model.settings);
        rebuild_chart(settings, data_obs, context).then(function(chart_result) {
            var result = chart_result.result;
            var dataset_meta = chart_result.dataset_meta;
            var model = ko.unwrap(data_obs);
            if (result.icon) {
                widget_model.icon(result.icon);
            }
            /*
            if (result.colour) {
                widget_model.colour(result.colour);
            }
            */
            var sc = ko.unwrap(allbindings().show_colour);
            if (sc) {
                ko.bindingHandlers.colour.update(
                    elt,
                    function() { return model.colour; },
                    function() { return { class_prefix:"bg-"}; }
                );
            }
            var title = ko.unwrap(model.settings).chart_title || ko.unwrap(dataset_meta.title);
            if (!title) {
                widget_model.show_header(false);
                widget_model.panel_class(null);
            }
            else
            {
                widget_model.title("<h3 class='box-title'>"+title+"</h3>");
                var chart_icon  = ko.unwrap(dataset_meta.icon);
                if (chart_icon)
                {
                    widget_model.icon("fa " + chart_icon);
                }
                else
                {
                    widget_model.icon("fa fa-bar-chart-o");
                }
                //widget_model.icon(ko.unwrap(widget_model.settings).icon || "fa fa-chart");
                widget_model.panel_class("box box-starship");
                widget_model.show_header(true);
            }
            uly.publish("widget.active", elt);
        });

        widget_model.title('<h3 class="box-title">{0}</h3>'.format(_("chart_loading", "Loading...")));
        widget_model.icon("fa fa-spinner");
        uly.publish("widget.active", elt);
    }
};
ko.virtualElements.allowedBindings.chart = true;
var chart_idx = 0;


var chart_types = {
    "bar":bar_chart,
    "pie":pie_chart,
    "line":bar_chart,
    "stream": bar_chart,
    "x_pie": pie_chart,
    "choropleth": choropleth_chart
};

var recreate_chart = function recreate_chart(elt, selector, chart_model, chart_settings, click_callback) {
    var series = ko.unwrap(chart_settings.series);
    var dimfield = ko.unwrap(chart_settings.sub_dimension) || ko.unwrap(chart_settings.dimension);
    var pivotfield = ko.unwrap(chart_settings.sub_pivot) || ko.unwrap(chart_settings.pivot);

    var chart_info = {};
    var chart_type = ko.unwrap(chart_settings.charttype) || "bar";
    var chart_class = chart_types[chart_type] || chart_types.bar;
    var chart_creator = chart_class.init;

    chart_info.map = {};
    chart_info.captions = {};
    chart_info.map[dimfield] = dimfield;

    if (pivotfield)
        chart_info.map[pivotfield] = pivotfield;

    $.each(series, function(idx, serie) {
        var valuefield = ko.unwrap(serie.value);
        chart_info.map[valuefield] = "_val"+(idx+1);
    });

    //process the columns for their captions
    var dataset_meta = ko.unwrap(chart_model.dataset_meta);
    if (!dataset_meta)
        return null;
    $.each(dataset_meta.dimensions, function(idx, dim) {
        chart_info.captions[dim.field] = dim.description || dim.field;
    });
    $.each(dataset_meta.fact_fields, function(idx, fact) {
        chart_info.captions[fact.field] = fact.description || fact.field;
    });
    chart_info.chart_type = chart_type;
    chart_info.map_file = ko.unwrap(chart_settings.map_file) || "world-countries.json";
    chart_info.caption_no_dimension = ko.unwrap(chart_settings.caption_no_dimension);
    chart_info.caption_no_pivot = ko.unwrap(chart_settings.caption_no_pivot);
    //create the chart structure (but not rendered)
    var chart = chart_creator(chart_info, dimfield, pivotfield, ko.toJS(series), click_callback, ko.unwrap(chart_settings.pivot_on_same_chart));
    chart_info.chart = chart;

    chart.initialisation_func(selector);

    return chart_info;
};


var initialise_chart = function initialise_chart_element(elt)  {
    d3.select($(elt).children("svg")[0]).selectAll("*").remove();
    $(elt).empty();

    var elt_id = $(elt).attr("id");
    if (!elt_id) {
        elt_id = "d3chart_"+chart_idx++;
        $(elt).attr("id", elt_id);
    }
    return "#"+elt_id;
};

function click_chart_value(settings, field_map, chart_model, d) {
    // get those out of closure
    var settings = ko.unwrap(settings);
    var dimfield = ko.unwrap(settings.sub_dimension) || ko.unwrap(settings.dimension);
    var pivotfield = ko.unwrap(settings.sub_pivot) || ko.unwrap(settings.pivot);
    var actual_dim_field = field_map[dimfield];
    var actual_dim_field_1 = field_map[dimfield+"_1"];
    var actual_dim_field_2 = field_map[dimfield+"_2"];
    var actual_dim_field_3 = field_map[dimfield+"_3"];
    if (pivotfield) {
        var actual_pivot_field = field_map[pivotfield];
        var actual_pivot_field_1 = field_map[pivotfield+"_1"];
        var actual_pivot_field_2 = field_map[pivotfield+"_2"];
        var actual_pivot_field_3 = field_map[pivotfield+"_3"];
    }
    var column_expression = ko.unwrap(chart_model.column_expression);
    var pivot_expression = ko.unwrap(chart_model.pivot_expression);

    var dim_values = [];
    var dim_value = d.point[actual_dim_field];
    dim_values.push(dim_value || null);
    dim_values.push(d.point[actual_dim_field_1] || null);
    dim_values.push(d.point[actual_dim_field_2] || null);
    dim_values.push(d.point[actual_dim_field_3] || null);

    var pivot_values = [];
    if (pivotfield) {
        pivot_values.push(d.point[actual_pivot_field] || null);
        pivot_values.push(d.point[actual_pivot_field_1] || null);
        pivot_values.push(d.point[actual_pivot_field_2] || null);
        pivot_values.push(d.point[actual_pivot_field_3] || null);
    }

    var filter = null;
    if (column_expression) {
        dim_values = $.map(dim_values, function(val,idx) {
            if (val instanceof Date)
                val = val.toISOString();
            return "{0}".format([val === null ? "null" : val]);
        });
        filter = column_expression.format(dim_values);
    }

    if (pivot_expression) {
        pivot_values = $.map(pivot_values, function(val,idx) {
            if (val instanceof Date)
                val = val.toISOString();
            return "{0}".format([val === null ? "null" : val]);
        });
        if (filter)
            filter = [filter, pivot_expression.format(pivot_values) ];
        else filter = pivot_expression.format(pivot_values);
    }
    return filter;
}
ko.bindingHandlers.gridchart = {
    "init":function gridchart_init(elt, va, allbindings, model, context) {
        var grid_data = {
            data: ko.pureComputed(()=>{
                var chart_result = ko.unwrap(va());
                var raw_data = ko.toJS(chart_result.data);
                var chart_type = ko.unwrap(ko.unwrap(va()).settings.charttype) || "bar";
                var chart_model = chart_result;
                var new_chart_settings = ko.toJSON(chart_model.settings);
                    //chart has changed.
                    //var selector = initialise_chart(elt);
                var click_value = function click_value(d, spec){
                    var filter = click_chart_value(chart_model.settings, chart_info.map, chart_model, d);
                    chart_model.drill_down_value(filter);
                };
                var chart_info = recreate_chart(elt, null, ko.unwrap(chart_result), ko.unwrap(chart_result.settings), click_value);

                if (!chart_info)
                    return null;

                if (chart_result.map)
                    $.extend(chart_info.map, ko.toJS(chart_result.map));

                var chart = chart_info.chart;
                var chart_data, chart_hashes;
                [chart_data, chart_hashes] = chart.update_data(raw_data);
                var flattened_data = chart_data.map(
                   (cd) => {
                       var flat_chart = [];
                       for (var i=1;i<cd.columns[0].length;++i) {
                            var datum = cd.columns.map((col) => col[i]);
                            flat_chart.push(datum);
                       }
                       var cols = cd.columns.map((col) => {
                           return col[0] == "x" ? " " : (chart_info.captions[col[0]] || col[0]);
                       })
                       return { 
                           "data": flat_chart,
                           "cols": cols
                       };
                   } 
                );
                return {
                    "data": chart_data,
                    "flattened": flattened_data,
                    "chart_info": chart_info,
                    "hashes": chart_hashes,
                    "raw_data": raw_data
                };
            }),
            click_row: (row, context) => {
                var chart_model = ko.unwrap(va());
                var data = ko.unwrap(grid_data.data);
                var hashes = data.hashes;
                var index = context.$index();
                var chart_index = context.$parentContext.$index();
                var raw_index = hashes[chart_index+"_"+index];
                var field_map = ko.unwrap(context.$parents[2].map);
                if (typeof raw_index != "undefined") {
                    var datum = data.raw_data[raw_index];
                    if (datum) {
                        var filter = click_chart_value(chart_model.settings, field_map, chart_model, { "point": datum} );
                        chart_model.drill_down_value(filter);

                    }
                }
            }
        };
        ko.applyBindingsToDescendants(context.createChildContext(grid_data), elt);
        return { "controlsDescendantBindings":true };
    }
};

ko.bindingHandlers.d3chart = {
    "init":function d3chart_init(elt, va, allbindings, model, context) {
        return { "controlsDescendantBindings":true };
    },
    "update":function d3chart_update(elt, va, allbindings, model, context) {
        var data = ko.unwrap(va());
        try {
            var chart_result = va();
            var data = ko.toJS(chart_result.data);
            var chart_info = $(elt).data("d3chartinfo");
            var previous_chart_settings = $(elt).data("d3chartsettings");
            var chart_type = ko.unwrap(ko.unwrap(va()).settings.charttype) || "bar";
            var chart_model = chart_result;
            var new_chart_settings = ko.toJSON(chart_model.settings);
            if (previous_chart_settings != new_chart_settings) {
                console.error("Change in settings...forcing reinitialiation", $(elt).attr("id"));
                chart_info = null;
                $(elt).data("d3chartsettings", new_chart_settings);
            }

            if (!chart_info || chart_type != chart_info.chart_type ) {
                //chart has changed.
                var selector = initialise_chart(elt);
                var click_value = function click_value(d, spec){
                    var filter = click_chart_value(chart_model.settings, chart_info.map, chart_model, d);
                    chart_model.drill_down_value(filter);
                };
                chart_info = recreate_chart(elt, selector, ko.unwrap(chart_result), ko.unwrap(ko.unwrap(va()).settings), click_value);
                $(elt).data("d3chartinfo", chart_info);
            }
            if (!chart_info)
                return;

            if (chart_result.map)
                $.extend(chart_info.map, ko.toJS(chart_result.map));

            var chart = chart_info.chart;
            var selector = "#"+$(elt).attr("id");
            chart.update_data_func(selector, data);
        }
        catch(e) {
            console.error("error:", e);
        }
    }
};

$(document).ready(function() {
    uly.widgets.register({
        "type":"chart",
        "caption":_("chart_caption_chart", "Chart"),
        "description":_("chart_description_a_graphical_representation_of_a_dataset", "A graphical representation of a dataset"),
        "icon":"fa-bar-chart-o",
        "init":function() {
            var data = {
                "dataset":ko.observable(null),
                "path":ko.observable(null),
                "series":ko.observableArray([{
                    "value":ko.observable(null),
                    "seriestype":ko.observable(null),
                    "stacked":ko.observable(false),
                    "alt_axis":ko.observable(false)
                }]),
                "dimension":ko.observable(null),
                "sub_dimension":ko.observable(null),
                "pivot":ko.observable(null),
                "sub_pivot":ko.observable(null),
                "charttype":ko.observable("bar"),
                "pivot_on_same_chart": ko.observable(false),
                "chart_title":ko.observable(null),
                "order_by":ko.observable(null),
                "limit":ko.observable(null),
                "extra_chart_filter":ko.observable(null),
                "extra_solr_filter":ko.observable(null),
                "caption_no_dimension": ko.observable(null),
                "caption_no_pivot": ko.observable(null),
                "show_as_grid": ko.observable(null)
            };
            var init_def = Promise.Deferred();
            select_chart(data).done(function(result) {

                data.dataset(result.dataset);
                data.path(result.path);


                data.dimension(result.dimension);
                data.sub_dimension(result.sub_dimension);
                data.charttype(result.charttype);
                data.chart_title(result.chart_title);
                data.pivot(result.pivot);
                data.order_by(result.order_by);
                data.limit(result.limit);
                data.extra_chart_filter(result.extra_chart_filter);
                data.extra_solr_filter(result.extra_solr_filter);
                data.caption_no_dimension(result.caption_no_dimension);
                data.caption_no_pivot(result.caption_no_pivot);
                data.sub_pivot(result.sub_pivot);
                data.pivot_on_same_chart(result.pivot_on_same_chart);
                data.show_as_grid(result.show_as_grid);
                var series = [];
                $.each(result.series, function(idx, serie) {
                    series.push({
                        "value":ko.observable(serie.value),
                        "seriestype":ko.observable(serie.seriestype),
                        "alt_axis":ko.observable(serie.alt_axis || false),
                        "stacked":ko.observable(serie.stacked || false)
                    });
                });
                data.series(series);
                init_def.resolve(ko.toJS(data));
            }).fail(init_def.reject);
            return init_def;
        },
        "colour":"jacksons-purple"
    });

    uly.actions.pickchart = function(e, $elt, ui) {
        var selected_chart = ko.unwrap(ui.model.name);
        ui.context.$parent.dataset(selected_chart.name);
        ui.context.$parent.selected_dataset(ui.model);


    };
    uly.actions.changechart = function(e,$elt,ui) {
        modify_chart(ui.context.$parent).done(function() {
            //reload_chart(ui.context.$parent);
        });
    };
    uly.actions.reloadchart = function(e,$elt, ui) {
        reload_chart(ui.context.$parent);
    };

});

export default {
    select_chart: select_chart
};
